import React from "react";
import ModalEditKeyCompetitive from "../../../company/profil/pitch/modal/modal-edit-key-competitive";
import { IProps } from "../../../company/profil/pitch/modal/modal-edit-key-competitive";
export default function ModalFundingRound(props: IProps) {
  return <ModalEditKeyCompetitive {...props} />;
}
